import { useEffect, useState, createRef } from "react";
import { LoadingContainer } from "./style";

const Loading = ({ loading }) => {
  const [videoStatus, setVideoStatus] = useState("start");
  const [status, setStatus] = useState(true);
  const [doNot, setDoNot] = useState(false);
  const logoMotion = createRef();
  useEffect(() => {
    if (!loading) {
      let visited = sessionStorage.getItem("visited");
      if (visited) {
        setStatus(false);
      } else {
        setVideoStatus("logo");
        logoMotion.current.play();
        let timeOut = setTimeout(() => {
          sessionStorage.setItem("visited", true);
          setStatus(false);
        }, 7000);
        return timeOut;
      }
    }
  }, [loading, logoMotion]);
  useEffect(() => {
    if (!status) {
      let timeOut = setTimeout(() => {
        setDoNot(true);
      }, 1000);
      return timeOut;
    }
  }, [status]);
  return (
    <LoadingContainer videoStatus={videoStatus} status={status} doNot={doNot}>
      <div className="video-mode">
        <video
          autoPlay
          muted
          className="start"
          onEnded={() => setVideoStatus("loop")}
        >
          <source src="/animate/LoadingStart.mp4" type="video/mp4" />
        </video>
        <video muted autoPlay className="loop" loop>
          <source src="/animate/LoadingLoop.mp4" type="video/mp4" />
        </video>
        <video
          muted
          ref={logoMotion}
          className="logo-motion"
          autoPlay={videoStatus === "logo"}
        >
          <source src="/animate/LoadingLogoMotion.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="git-mode">
        <img src="/animate/LoadingLoop.gif" alt="git" />
      </div>
    </LoadingContainer>
  );
};
export default Loading;
